import { defineStore } from 'pinia'
import { api } from '@/plugins/api'
import moment from 'moment'
export const wasabiStore = defineStore('wasabi', {
  state: () => ({
    loading: {
      accounts: false,
      account: false,
      buckets: false,
      invoices: false,
      preferences: false
    },
    listParams: {
      page: 1,
      pageSize: 10,
      sortBy: 'asc',
      orderBy: 'AcctNum',
      searchTerm: '',
      pages: 1,
      filter: null,
      count: 0
    },
    account: null,
    accounts: [],
    utilizationRange: {
      start: moment().subtract(1, 'months').format('MM/DD/YYYY'),
      end: moment().format('MM/DD/YYYY')
    },
    utilization: null,
    preferences: null,
    buckets: [],
    contents: [],
    continuationToken: 'paginate',
    maxKeys: 10,
    utilizationStatus: null,
    utilizationBuckets: null,
    isAccountChecked: false,
    filters: [
      {
        id: 999,
        name: 'All',
        value: null
      },
      {
        id: 2,
        name: 'Legacy',
        value: 'Legacy'
      },
      {
        id: 3,
        name: 'OPUS',
        value: 'OPUS'
      },
      {
        id: 4,
        name: 'Crash',
        value: 'Crash'
      },
      {
        id: 5,
        name: 'Gerber',
        value: 'Gerber'
      },
      {
        id: 1,
        name: 'Inactive',
        value: 'Inactive'
      },
      {
        id: 998,
        name: 'Missing Location',
        value: 'noLocation'
      },
      {
        id: 998,
        name: 'Missing Bucket',
        value: 'noBucket'
      }
    ],
    api_message: null,
    invoices: []
  }),
  actions: {
    setListParam(data) {
      this.listParams[data.name] = data.value
    },
    setLoading(data) {
      this.loading[data.name] = data.value
    },
    resetMessage() {
      this.api_message = null
    },
    resetAccounts() {
      this.api_message = null
      this.listParams = {
        page: 1,
        pageSize: 10,
        sortBy: 'asc',
        orderBy: 'AcctNum',
        searchTerm: '',
        pages: 1,
        filter: null,
        count: 0
      }
      this.accounts = []
      this.preferences = null
      this.isAccountChecked = false
    },
    resetAccount() {
      this.api_message = null
      this.account = null
      this.buckets = []
      this.contents = []
      this.continuationToken = 'paginate'
      this.utilizationRange = {
        start: moment().subtract(1, 'months').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
      this.preferences = null
    },
    setAccount(data) {
      switch (data.name) {
        case 'Checked': {
          this.isAccountChecked = false
          let found = this.accounts.find((x) => x.acctNum === data.id)
          if (found) {
            found.isChecked = data.value
            this.isAccountChecked = this.accounts.some((x) => x.isChecked)
          }
          break
        }
        case 'MaxKeys': {
          this.maxKeys = data.value
          break
        }
        case 'Paginate': {
          this.continuationToken = data.value
          break
        }
        case 'firm':
          this.account.firm = data.value
          break
        case 'appFirm':
          this.account.appFirm = data.value
          break
        case 'acctId':
          this.account.acctId = data.value
          break
        case 'acctKey':
          this.account.acctKey = data.value
          break
      }
    },
    setUtilizationRange(data) {
      if (this.utilizationRange) {
        if (data.name === 'start') {
          this.utilizationRange.start = data.value
        } else if (data.name === 'end') {
          this.utilizationRange.end = data.value
        }
      }
    },
    async getUtilizationBuckets(data) {
      let results = await api.get('wasabi/utilizationBuckets', data)
      if (results) {
        this.utilizationBuckets = results
      }
      return this.utilizationBuckets
    },
    async getUtilizationStatus() {
      let results = await api.get('wasabi/utilizationStatus')
      if (results) {
        this.utilizationStatus = results
      }
      return this.utilizationStatus
    },
    async getAccounts() {
      this.accounts = []
      this.isAccountChecked = false
      let options = {
        offset: (this.listParams.page - 1) * this.listParams.pageSize,
        pageSize: this.listParams.pageSize,
        sortBy: this.listParams.sortBy,
        orderBy: this.listParams.orderBy,
        searchTerm: this.listParams.searchTerm,
        filter: this.listParams.filter
      }
      this.loading.accounts = true
      let results = await api.get('wasabi/accounts', options)
      if (results) {
        this.accounts = results.items
        if (this.accounts) {
          this.accounts.forEach((element) => {
            element.isChecked = false
          })
        }
        this.listParams.count = results.count
        this.listParams.pages = Math.ceil(results.count / this.listParams.pageSize)
      }
      this.loading.accounts = false
      console.log('Got Accounts', this.accounts)
      return this.accounts
    },
    async getAccount(acctNum) {
      this.api_message = null
      this.utilization = null
      this.loading.account = true
      this.account = this.accounts.find((x) => parseInt(x.acctNum) === parseInt(acctNum))
      this.utilizationRange = {
        start: moment().subtract(180, 'day').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
      let data = {
        accountNumber: this.account.acctNum,
        start: moment().subtract(180, 'day').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      }
      let results = await api.get('wasabi/utilization', data)
      if (results) {
        this.utilization = results
      }
      await this.getAccountBuckets(acctNum)
      this.loading.account = false
      console.log('Got Account', this.account)
      console.log('Got Account Utilization', this.utilization)
      return this.account
    },
    async getAccountBuckets(acctNum) {
      this.buckets = []
      this.loading.buckets = true
      let results = await api.get(`wasabi/buckets?accountId=${this.account.acctId}&accountKey=${this.account.acctKey}&accountNumber=${acctNum}`)
      if (results) {
        if (Array.isArray(results)) {
          results.forEach((element) => {
            let found = this.buckets.find((x) => parseInt(x.bucketNum) === parseInt(element.BucketNum))
            if (found) {
              found.numBytes = element.MetadataStorageSizeBytes
              found.numFiles = element.NumBillableObjects
            } else {
              if (element.BucketNum) {
                this.buckets.push({
                  number: element.BucketNum,
                  name: element.Bucket,
                  region: element.Region,
                  numBytes: element.MetadataStorageSizeBytes,
                  numObjects: element.NumBillableObjects
                })
              } else {
                this.buckets.push({
                  number: null,
                  name: element.name,
                  region: null,
                  numBytes: 0,
                  numObjects: 0
                })
              }
            }
          })
        } else {
          if (results.Message) {
            this.api_message = results.Message
          }
        }
      }
      this.loading.buckets = false
      console.log('Got Buckets', this.buckets)
    },
    async getAccountUtilization(data) {
      this.utilization = null
      let results = await api.get('wasabi/utilization', data)
      if (results) {
        this.utilization = results
      }
      return this.utilization
    },
    async searchAccount(name) {
      this.preferences = null
      this.loading.search = true
      let response = await api.get(`wasabi/search?accountName=${name}`)
      if (response) {
        this.preferences = response
      }
      this.loading.search = false
      console.log('Got Preferences', this.preferences)
    },
    async deleteAccounts() {
      let results = null
      let accounts = this.accounts.filter((x) => x.isChecked)
      if (accounts.length > 0) {
        let accountNumbers = accounts.map((x) => x.acctNum)
        results = await api.delete('wasabi/accounts', accountNumbers)
      }
      return results
    },
    async getBucketContents(bucket) {
      if (this.continuationToken === 'paginate') {
        this.contents = []
      }
      let data = {
        account: this.account.acctNum,
        id: this.account.acctId,
        key: this.account.acctKey,
        bucket: bucket.name,
        region: bucket.region,
        maxKeys: this.maxKeys,
        continuationToken: this.continuationToken
      }
      let response = await api.get('wasabi/bucketContent', data)
      if (response) {
        if (this.continuationToken === 'paginate') {
          this.contents = response
        } else {
          response.forEach((element) => {
            this.contents.push(element)
          })
        }
        if (this.contents.length > 0) {
          this.continuationToken = this.contents[this.contents.length - 1].continuationToken
        }
      }
      console.log('Got Bucket Contents', {
        contents: this.contents,
        continuationToken: this.continuationToken
      })
    },
    async getPresignedUrl(data) {
      return await api.get('wasabi/presignedUrl', data)
    },
    async createBucket(data) {
      return await api.post('wasabi/createBucket', data)
    },
    async saveAccount(data) {
      let results = null
      if (data) {
        results = await api.post('wasabi/account', data)
      } else {
        results = await api.post('wasabi/account', {
          acctNum: this.account.acctNum,
          firm: this.account.firm,
          appFirm: this.account.appFirm,
          acctId: this.account.acctId,
          acctKey: this.account.acctKey
        })
      }
      return results
    },
    async getInvoices(acctNum) {
      this.loading.invoices = true
      let results = await api.get(`wasabi/invoices?accountNumber=${acctNum}`)
      if (results) {
        this.invoices = results
      }
      this.loading.invoices = false
      return this.invoices
    },
    async createAccount(firm) {
      return await api.get(`wasabi/createAccount?firm=${firm}`)
    }
  }
})
